import { IPublishInfoServicesToDeactivate } from '../../../redux/reducers';
import {
  ICheckPublishResponseServicesToDeactivate,
} from '../../../repositories/monolith-python/entities/CheckPublishResponseSchema';

export const mapServicesToDeactivate = (
  services: Array<ICheckPublishResponseServicesToDeactivate> | null | undefined,
): Array<IPublishInfoServicesToDeactivate> | null => {
  if (!Array.isArray(services)) {
    return null;
  }

  return services.map(({ serviceTypes, serviceName, paidTill }) => ({ serviceTypes, serviceName, paidTill }));
};
